import type { FC } from 'react';

type IconProps = {
    className?: string;
};

export const FontChangeIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        {/* ⇄ のような左右矢印が上下にあるアイコン */}
        <g
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        >
            {/* 上段：右向き矢印 */}
            <path d="M5 8h10" />
            <path d="M15 5l4 3-4 3" />

            {/* 下段：左向き矢印 */}
            <path d="M19 16H9" />
            <path d="M9 13l-4 3 4 3" />
        </g>
    </svg>
);
